import { useRef, useState } from 'react';

const useAudioRecorder = (sendAudio: (audioBlob: Blob) => void) => {
  const mediaRecorderRef = useRef<MediaRecorder | null>(null);
  const audioChunksRef = useRef<Blob[]>([]);
  const [isListening, setIsListening] = useState(false);

  const startListening = async () => {
    if (isListening) return;
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      mediaRecorderRef.current = new MediaRecorder(stream);

      mediaRecorderRef.current.addEventListener('dataavailable', (event) => {
        audioChunksRef.current.push(event.data);
      });

      mediaRecorderRef.current.addEventListener('stop', () => {
        const audioBlob = new Blob(audioChunksRef.current, {
          type: 'audio/mp3', // or the correct MIME type
        });
        sendAudio(audioBlob);
        audioChunksRef.current = [];
        setIsListening(false);
      });

      mediaRecorderRef.current.start();
      setIsListening(true);
    } catch (error) {
      alert('Error accessing microphone. Please check your audio permissions.');
      console.error('Error starting audio recording:', error);
    }
  };

  const stopListening = () => {
    if (mediaRecorderRef.current) {
      mediaRecorderRef.current.stop();
    } // setIsListening will be set in the 'stop' event listener
  };

  return {
    startListening,
    stopListening,
    isListening,
    recorder: mediaRecorderRef.current,
  }; // Return recorder instance
};

export default useAudioRecorder;
